function accountService() {
  let accountService = [
    {
      name: "Account Mangement",
      icon: "account-management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "account",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/account-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  
  

   const MerchantConfiguration = () => {
    const MerchantConfigurationArr = [
      {
        path: "/index/merchantconfiguration",
        name: "Merchant Configuration",
        icon: "twoFactorAuthentication",
        logoName: "twoFactorAuthentication",
        flag: "IP WHITELIST",
      },
    ];

    return MerchantConfigurationArr;
  };

  const cutomerMaster = () => {
    const profileArr = [
      {
        path: "/index/customer-master",
        name: "Customer Master",
        icon: "customer-master",
        logoName: "customer master",
        flag: "CUSTOMER MASTER",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const createWallet = () => {
    const mybanksArr = [
      {
        // path: "/index/create-wallet",
        path: "/index/customer-wallet",
        // name: "Create Wallet",
        name: "Customer Wallet",
        icon: "MyWallets",
        logoName: "MyWallets",
        flag: "CREATE WALLET",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const feeWallet = () => {
    const myFeeWalletArr = [
      {
        path: "/index/fee-wallet",
        name: "Fee Wallet",
        icon: "MyWallets",
        logoName: "Fee Wallet",
        flag: "FEE WALLET",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return myFeeWalletArr;
    // } else {
    //   return "";
    // }
  };

  const manualOtpRequest = () => {
    const mycardsArr = [
      {
        path: "/index/manual-otp-request",
        name: "Manual OTP Request",
        icon: "manual-otp-request",
        logoName: "manual otp request",
        flag: "OTP REQUEST",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const manulUpgradeRequest = () => {
    const mywalletsArr = [
      {
        path: "/index/manual-upgrade-request",
        name: "Manual-Upgrade-Request",
        icon: "manual-upgrade-request",
        logoName: "manual update request",
        // flag: "isMyWalletAllowed",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mywalletsArr[0].flag])
    // ) {
    return mywalletsArr;
    // } else {
    //   return "";
    // }
  };

    const customerBanks = () => {
    const mywalletsArr = [
      {
        path: "/index/customer-bank",
        name: "Customer Bank",
        icon: "MyBank",
        logoName: "MyBank",
        flag: "CREATE WALLET",
        // flag: "isMyWalletAllowed",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mywalletsArr[0].flag])
    // ) {
    return mywalletsArr;
    // } else {
    //   return "";
    // }
  };
  const TwoFaAuthentication = () => {
    const TwoFaAuthenticationArr = [
      {
        path: "/index/two-fa-authentication",
        name: "2F Authentication",
        icon: "twoFactorAuthentication",
        logoName: "twoFactorAuthentication",
        flag: "TWO FACTOR AUTHENTICATION",
      },
    ];

    return TwoFaAuthenticationArr;
  };

    const GenerateLink = () => {
    const GenerateLinkArr = [
      {
        path: "/index/generatelink",
        name: "Generate Link",
        icon: "twoFactorAuthentication",
        logoName: "generatelink",
        flag: "GENERATE LINK",
      },
    ];

    return GenerateLinkArr;
  };

  let a = dashboard();
  let b = cutomerMaster();
  let c = createWallet();
  let d = feeWallet();
  let e = manualOtpRequest();
  let f = manulUpgradeRequest();
  let h = customerBanks();
  let g = TwoFaAuthentication();
  let i = MerchantConfiguration();
  let j= GenerateLink();
  // accountService[0].items = [...a, ...b, ...c, ...d, ...e];
  accountService[0].items = [...a, ...b, ...c, ...d, ...e, ...g, ...h, ...i, ...j];

  return accountService;
}

export default accountService;
